import {BoxProps, Button, ButtonProps} from "@mui/joy";
import {statusPalettes, useSelfShiftInfo} from "../agent/diary.tsx";
import {useState} from "react";
import {isEmpty} from "lodash";
import {SxProps} from "@mui/joy/styles/types";
import {useSetlistConnectionStatus} from "../rpc/setlist.tsx";
import {Veiled} from "./Veil.tsx";
import {mergeSx} from "../components/joyx.tsx";
import {useBomb} from "../bomb/bomb.tsx";
import {errorize} from "../bomb/errorize.tsx";
import {Keyed} from "../util/arutil.tsx";

function useShiftStatusJoyProps(): Partial<ButtonProps> {
    const {data: statusData} = useSelfShiftInfo();
    const status = statusData?.status;
    return status === "onDuty"
        ? {}
        : {
            disabled: true,
            color: status ? statusPalettes[status] : "neutral",
            variant: "outlined",
        }
}

// only elastic action buttons can be pressed more than once
export interface ActionButtonProps extends Omit<ButtonProps, "onClick"> {
    veilSx?: BoxProps["sx"];
    perform?: () => Promise<unknown>;
    elastic?: boolean;
}

// const StyledActionButton
//     = styled(Button, {
//     name: "ActionButton",
//     slot: "root",
// })<{ ownerState: ActionButtonProps }>({
//     borderRadius: "8px",
// });

export function ActionButton(inProps: ActionButtonProps) {
    const {
        ref,
        perform,
        elastic,
        children,
        sx: inButtonSx,
        veilSx: inVeilSx,
        ...rest
    } = inProps;
    const [isActing, setIsActing]
        = useState<boolean>(false);
    const bomb = useBomb();
    const shiftStatusProps = useShiftStatusJoyProps();
    const veilSx = mergeSx({}, inVeilSx);
    const buttonSx = mergeSx({
        borderRadius: "8px"
    }, inButtonSx);
    const buttonProps = {
        ...rest,
        ...shiftStatusProps,
        sx: buttonSx,
    }
    if (isActing) {
        buttonProps.disabled = true;
    }
    const setlistConnectionStatus = useSetlistConnectionStatus();
    if (setlistConnectionStatus !== "up") {
        buttonProps.disabled = true;
    }

    const performHandler = perform
        ? {
            onClick: () => {
                setIsActing(true);
                perform().then(() => {
                    if (elastic) {
                        setIsActing(false);
                    }
                }).catch((xc: unknown) => {
                    if (elastic) {
                        setIsActing(false);
                    }
                    const error = errorize(xc);
                    bomb(error);
                });
            }
        }
        : {};
    return <Veiled sx={veilSx} child={() => <Button {...buttonProps} ref={ref} {...performHandler}>
        {children}
    </Button>}
                   topcoatGradientPalette="danger" variant="solid"
                   lifted={!buttonProps.disabled}/>

    // return <Button {...props} ref={ref} {...performHandler}>
    //     {children}
    // </Button>
}

export function buildActionButtons(commonSx: SxProps, kprops: Keyed<ActionButtonProps>[] | undefined) {
    if (!kprops || isEmpty((kprops))) {
        return null;
    }
    return <>{kprops.map(kp => {
        const {sx: inSx, children, ...rest} = kp.elem;
        return <ActionButton size="lg" sx={mergeSx(commonSx, inSx)} {...rest} key={kp.key}>
            {children}
        </ActionButton>
    })}</>;
}
